module.exports = __webpack_public_path__ + "media/צב.db14d0ea.mp3";